/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCrop32Filled = createReactComponent("filled", "crop-3-2-filled", "IconCrop32Filled", [["path", { "d": "M18 6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

export { IconCrop32Filled as default };
//# sourceMappingURL=IconCrop32Filled.mjs.map
